"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropTypeError = PropTypeError;
exports.default = void 0;
var ANONYMOUS = '<<anonymous>>';

function PropTypeError(message) {
  this.message = message;
  this.stack = '';
}

PropTypeError.prototype = Error.prototype;

var wrapValidator = function wrapValidator(validate) {
  var checkType = function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        if (props[propName] === null) {
          return new PropTypeError("The ".concat(location, " `").concat(propFullName, "` is marked as required ") + "in `".concat(componentName, "`, but its value is `null`."));
        }

        return new PropTypeError("The ".concat(location, " `").concat(propFullName, "` is marked as required in ") + "`".concat(componentName, "`, but its value is `undefined`."));
      }

      return null;
    }

    var result = validate(props, propName, componentName, location, propFullName, secret);

    if (result !== null) {
      result = new PropTypeError(result);
    }

    return result;
  };

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
};

var _default = wrapValidator;
exports.default = _default;